import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import img1 from "../../assets/image/home2.jpg";
import img2 from "../../assets/image/home1.jpg";
import img3 from "../../assets/image/hom3.jpg";
import { Link } from "react-router-dom";
AOS.init({ duration: 1000 });

export default function LastSec() {
  const images = [img1, img2, img3];

  return (
    <section className="py-5 bg-light position-relative overflow-hidden">
      <Container>
        <Row className="align-items-center" dir="rtl">
          <Col md={6} data-aos="fade-right">
            <div className="p-3">
              <h2 className="fw-bold mb-3 text-dark display-6">
                دعنا نساعدك في تخطيط رحلتك القادمة
              </h2>
              <p className="mb-4 fs-5 text-muted lh-lg">
بتوفير احتياجك وصنع بسمتك بكل اريحيه              </p>
         <Link to="/contact">
  <button className="btn btn-danger btn-lg rounded-pill px-5 shadow">
    تواصل معنا
  </button>
</Link>
            </div>
          </Col>

          <Col md={6} data-aos="fade-left">
            <div className="slider-wrapper  rounded-5 p-4 ">
              <Swiper
                slidesPerView={1}
                loop={true}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                modules={[Autoplay]}
              >
                {images.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="d-flex justify-content-center">
                      <img
                        src={img}
                        alt={`slide-${idx}`}
                        className="img-fluid rounded-4 shadow-sm"
                        style={{ width: '100%', maxWidth: '500px', height: '350px', objectFit: 'cover', borderRadius: '20px' }}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
